import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    viewBox="0 0 17 17" {...props}
  >
    <path
      fill="#0535E4"
      fillRule="evenodd"
      d="M2.667 2.333C2.667 1.597 3.264 1 4 1h8c.737 0 1.334.597 1.334 1.333V13a.667.667 0 0 1-1.054.543l-1.946-1.39-1.946 1.39a.67.67 0 0 1-.775 0l-1.946-1.39-1.946 1.39A.667.667 0 0 1 2.667 13zM5.334 4c0-.368.298-.667.666-.667h4a.667.667 0 1 1 0 1.334H6A.667.667 0 0 1 5.334 4M6 6a.667.667 0 0 0 0 1.333h4A.667.667 0 1 0 10 6zm0 2.667A.667.667 0 1 0 6 10h4a.667.667 0 1 0 0-1.333z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInvoiceNotification;
